<template>
  <v-snackbar v-model="newNotificationAlert" :timeout="timeout" multi-line top right>
    <div @click="goToAction">{{ text }}</div>
    <template v-slot:action="{ attrs }">
      <v-btn color="yellow" text v-bind="attrs" @click="onClickClose">
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'NotificationAlert',
  data: () => ({
    newNotificationAlert: false,
    text: '',
    action: null,
    timeout: 6000
  }),
  methods: {
    goToAction: function () {
      if (this.action) {
        window.location.href = this.action
      }
    },
    connectToStore: function () {
      // TODO: get LAST EVENTS
      if (this.$store.state.notifications.length > 0) {
        this.$store.dispatch('processQueue')
      }
    },
    onClickClose: function () {
      this.newNotificationAlert = false
    },
    registerListenEvents () {
      const storedData = localStorage.getItem('user')
      const data = JSON.parse(storedData)
      if (!data) {
        return false
      }

      // eslint-disable-next-line no-undef
      Echo.private(`App.User.${data.id}`).notification((notification) => {
        this.$store.dispatch('addNotificationToQueue', { notification })

        if (!this.processingNotificationQueue) {
          this.$store.dispatch('processQueue')
        }

        // TODO: REfresh count number
      })
    }
  },
  created () {
    this.connectToStore()
    this.registerListenEvents()
  },
  computed: {
    ...mapState(['notificationDisplayCurrent', 'processingNotificationQueue'])
  },
  watch: {
    newNotificationAlert (newValue) {
      if (newValue === false) {
        setTimeout(() => {
          this.$store.dispatch('showNextInQueue')
        }, 400)
      }
    },
    notificationDisplayCurrent (newValue, oldValue) {
      if (newValue.text) {
        this.newNotificationAlert = true
        this.text = this.notificationDisplayCurrent.text
        this.action = this.notificationDisplayCurrent.action
      }
    }
  }
}
</script>

<style scoped></style>
